import { CSSProperties, useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { CardRenderContext } from '@shared/components/blocks/contexts/render';
import { Pill, PillColor } from '@shared/components/pill';
import { grid } from '@shared/styles';

interface TagProps {
  label: string;
  color?: PillColor;
  archived?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function Tag({ label, color, archived, style, textStyle }: Readonly<TagProps>) {
  const renderContext = useContext(CardRenderContext);
  const isCalendar = renderContext === 'calendar';

  const baseViewStyle: ViewStyle = isCalendar ? { margin: 0, marginRight: grid(1) } : {};
  const baseTextStyle: CSSProperties = isCalendar
    ? { fontSize: 14, lineHeight: '18px', letterSpacing: -0.2 }
    : {};

  return (
    <Pill
      round
      italic={archived}
      backgroundColor={archived ? 'backgroundGrayLight' : color}
      style={[baseViewStyle, style]}
      textStyle={{ ...baseTextStyle, ...textStyle }}
    >
      {label}
    </Pill>
  );
}
